import { render, staticRenderFns } from "./CenterForm.vue?vue&type=template&id=59f4bea4&scoped=true&"
import script from "./CenterForm.vue?vue&type=script&lang=ts&"
export * from "./CenterForm.vue?vue&type=script&lang=ts&"
import style0 from "./CenterForm.vue?vue&type=style&index=0&id=59f4bea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4bea4",
  null
  
)

export default component.exports